




























































import Vue from 'vue';
import _ from 'lodash';
import store from '@/store';
import PropertyResultsMap from './property-results-map.vue';
import PropertyResultsCards from './property-results-cards.vue';
import { API } from "aws-amplify";
import { Constants } from "@/api-constants";
import { getModule } from "vuex-module-decorators";
import Properties from "@/store/property/Properties";
import FavouritesModule from "@/store/Favourites";
import { Component, Prop } from "vue-property-decorator";
import AuthLogin from "@/components/auth/auth-login.vue";
import ViewpointSelector from "@/components/common/viewpoint-selector.vue";

const propertiesModule = getModule(Properties)
const favouritesModule = getModule(FavouritesModule);
@Component({
  components: {
    'property-results-map': PropertyResultsMap,
    'property-results-cards': PropertyResultsCards,
  }
})
export default class PropertyResults extends Vue {

  @Prop({
    type: String,
    default: '',
  })
  searchQuery!: string


  erroredGet = false
  countResults = 0 as any
  lastUpdatedDate = '' as string
  pageSize = 18
  pageOffset = 1


  get titleSize(): string {
    switch (this.$vuetify.breakpoint.name) {
      case 'xs':
        return 'title';
      default:
        return 'headline';
    }
  }

  get choices() {
    return propertiesModule.properties
  }

  get choicesScores() {
    return propertiesModule.propertiesScores
  }

  get sortedProperties() {
    return propertiesModule.sortedScores.filter(p => this.choices[p.id])
  }

  get favourites() {
    return favouritesModule.favouriteIds
  }

  get loadingChoices() {
    return !Object.values(this.choicesScores).length || !Object.values(this.choices).length
  }


  formatDate(date: Date) {
    let options: object = {year: 'numeric', month: 'long', day: 'numeric'};
    let locale: string = 'en-US';
    return date.toLocaleDateString(locale, options);
  }

}

